import * as AppDimensions from "../constants/AppDimensions";
import * as DateUtil from './DateUtil'

export const addItemAtIndex = (list, index ,item) => {
  return [...list.slice(0, index),
    item,
    ...list.slice(index+1)]
};

export const isErrorResponse = (response) => {
  return response.data.error !== undefined
};

export const hasRateByDays = (response) => {
  let hasRates = false;

  if (response.data.properties) {
    response.data.properties.forEach(property => {
      if(property.inventory) {
        property.inventory.forEach(inventory => {
          if(inventory.rateByDay && inventory.rateByDay.length > 0) {
            hasRates = true;
          }
        })
      }
    });
  }

  return hasRates;
};

export const propertyHasRates = (property) => {
  let hasRates = false;

  if (property.inventory) {
    property.inventory.forEach(inventory => {
      if (inventory.rateByDay && inventory.rateByDay.length > 0) {
        if (inventory.rateByDay[0].singlePP !== undefined
            || inventory.rateByDay[0].roomRate !== undefined) {
          hasRates = true;
        }
      }
    })
  }

  return hasRates;
};

export const getRateCurrency = (property) => {
  let currency = '';

  if (property.inventory && property.inventory.length > 0) {
    if (property.inventory[0].rateByDay
        && property.inventory[0].rateByDay.length > 0) {
      if (property.inventory[0].rateByDay[0].currency !== undefined) {
        currency = property.inventory[0].rateByDay[0].currency;
      }
    }
  }

  return currency;
};

export const hasProperties = (response) => {
  let hasProperties = false;

  if (response.data.properties) {
      if(response.data.properties.length > 0) {
            hasProperties = true;
      }
  }

  return hasProperties;
};

export const insertSoldRateByDays = (response) => {
  return {
    ...response.data,
    properties:
        response.data.properties.map(property => {
          return {
            ...property, inventory:
                property.inventory.map(inventory => {
                  return {...inventory, rateByDay: buildRateByDays(response.data)}
                })
          }
        })

  };
};

const buildRateByDays = (data) => {
  let startDate = DateUtil.localDateFromString(data.availabilityRequest.startDate);
  let rateByDay = [];

  for(let i = 0; i < AppDimensions.noOfNights; i++) {
    rateByDay.push(
        {
          date: DateUtil.localDateToString(startDate.plusDays(i), 'yyyy-MM-dd'),
          roomsRemaining: 0
        }
    )
  }

  return rateByDay;
};

export const buildRateByDayUrl = (api_url) => {
  let url = '';
  if(api_url.endsWith('/')) {
    url = api_url.concat('ratebyday')
  }
  else {
    url = api_url.concat('/ratebyday')
  }

  return url;
};

export const waitFor = (ms) => new Promise(r => setTimeout(r, ms));

export const asyncForEach = async(array, callback) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
};


// WEBPACK FOOTER //
// ./src/utils/Util.js